import React, { useState } from 'react';
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser } from "@fortawesome/free-solid-svg-icons";
import FloatingActions, { FloatingAction } from "../FloatingActions";
import Card from "../Card";
import useAppData from "@/store/useAppData";
import axios from "axios";
import DialogWindow from '../DialogWindow';

export interface NewRecordCardProps {
    onSave: (newInventoryId: string | null) => void;
}

const NewInventoryCard: React.FC<NewRecordCardProps> = ({
    onSave,
}) => {
    
    const selectedStock = useAppData(state => state.selectedStock);

    const [name, setName] = React.useState("");
    const [date, setDate] = React.useState(new Date());
    const [error, setError] = React.useState<string | null>(null);
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [dialogText, setDialogText] = useState<string>("");

    const validate = () => {
        const n = name.trim();

        if (!n || !date) return "Vyplňte povinná pole Název a Datum";
        return null;
    };

    const onCreate = async () => {
        setError(null);
        const validationError = validate();
        if (validationError) {
            setError(validationError);
            return;
        }

        let success = true;
        const resultNewInventoryId = await insertNewInventory(selectedStock.id, name, date.toISOString());

        if (!resultNewInventoryId) {
            success = false;
        } else {
            const resultmoveStockItemToInventorySuccess = await moveStockItemToInventory(selectedStock.id, resultNewInventoryId);

            if (!resultmoveStockItemToInventorySuccess) {
                success = false;
            }
        }

        if (success) {
            onSave(resultNewInventoryId);
        } else {
            setDialogText("Došlo k chybě při vytváření nové inventury");
            setShowDialog(true);
        }
    };

    const actions: FloatingAction[] = [
        {
            key: "cancel",
            label: "Zrušit",
            icon: <FontAwesomeIcon icon={faUser} />,
            onClick: () => onSave(null),
        },
        {
            key: "save",
            label: "Vytvořit",
            icon: <FontAwesomeIcon icon={faHome} />,
            onClick: onCreate,
        },
    ];

    const insertNewInventory = async (stockId: string, description: string, date: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventory/insert",
                data: {
                    stockId: stockId,
                    description: description,
                    date: date
                },
            });

            return res.data?.id;
        } catch (err) {
            console.error("Failed to insert inventory item", err);
            throw err;
        }
    };

    const moveStockItemToInventory = async (stockId: string, inventoryId: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventory/moveItems",
                data: {
                    stockId: stockId,
                    inventoryId: inventoryId
                },
            });

            return res.data?.ok;
        } catch (err) {
            console.error("Failed to move stock items to inventory", err);
            throw err;
        }
    };

    return (
        <>
            {showDialog &&
                <DialogWindow
                    displayDialog={showDialog}
                    setDisplayDialog={setShowDialog}
                    title={dialogText}
                    cancelText={"OK"}
                />
            }

            <Card title="Nová inventura">
                <div className="nec-stack">
                    <div className="nec-block">
                        <div className="nec-header">Název</div>
                        <div className="nec-control">
                            <input
                                className="nec-input"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Název inventury..."
                                autoComplete="off"
                            />
                        </div>
                    </div>

                    <div className="nec-block">
                        <div className="nec-header">Datum</div>
                        <div className="nec-control">
                            <input
                                className="nec-input"
                                type="date"
                                value={date.toISOString().split('T')[0]}
                                onChange={(e) => setDate(new Date(e.target.value))}
                            />
                        </div>
                    </div>

                    {error ? <div className="form-error">{error}</div> : null}
                </div>

                {actions?.length ? (
                    <div className="item-list-actions">
                        <FloatingActions actions={actions} />
                    </div>
                ) : null}
            </Card>
        </>);
};

export default NewInventoryCard;